// eslint-disable-next-line @github-ui/github-monorepo/filename-convention
const recencyTimeRange = 2 * 365 * 24 * 60 * 60 * 1000 // 2 years

// See app/view_models/blob/blame_view.rb for breakpoints
const blameAgeProportionBreakpoints = [0.007, 0.014, 0.03, 0.049, 0.084, 0.14, 0.23, 0.38, 0.62, Number.MAX_VALUE]

// Primer CSS variables auto-adapt to light/dark/high-contrast themes
const scaleColor = (i: number) => `var(--display-orange-scale-${i})`

// eslint-disable-next-line @eslint-react/no-unnecessary-use-prefix -- keeping hook name for API stability
export function useBlameAgeColors() {
  return new Array(10).fill(null).map((_, i) => scaleColor(i))
}

// eslint-disable-next-line @eslint-react/no-unnecessary-use-prefix -- keeping hook name for API stability
export function useBlameAgeColor(commitDate: Date, repoCreationDate: Date) {
  const defaultColor = scaleColor(0)

  if (commitDate < repoCreationDate) {
    // This is a silly edge case, but it can happen in test data
    return defaultColor
  }

  const now = Date.now()
  const timeRange = Math.min(now - repoCreationDate.getTime(), recencyTimeRange)
  const commitAge = now - commitDate.getTime()

  const proportion = commitAge / timeRange

  let i = 0
  for (const breakpoint of blameAgeProportionBreakpoints) {
    if (proportion < breakpoint) {
      return scaleColor(9 - i)
    }
    ++i
  }

  return defaultColor
}
